// NATIVE 
import React, { useEffect, useState } from 'react';


// INSTALLED 
import Box from '@mui/material/Box';
import { Formik, Form } from 'formik';
import Step from '@mui/material/Step';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';


// CUSTOM 
import Stepper from '@mui/material/Stepper';
import StepLabel from '@mui/material/StepLabel';
import { SnackAlert } from '../../components/SnackAlert';
import { InformacionBasica } from '../../components/empleado';
import { Familia } from '../../components/empleado/crear/Familia';
import { Laboral } from '../../components/empleado/crear/Laboral';
import MultipleSnackbars from '../../components/MultipleSnackbars';
import { Dotacion } from '../../components/empleado/crear/Dotacion';
import { getEmployeDataCreateStore, saveEmployee } from '../../store/employee';
import { PruebasIngreso } from '../../components/empleado/crear/PruebasIngreso';
import { Breadcrumbs, Button, Card, Divider,  Typography } from '@mui/material';
import { SeguridadSocial } from '../../components/empleado/crear/SeguridadSocial';
import validationSchema from '../../components/empleado/crear/formModels/validationSchema';
import formInitialValues from '../../components/empleado/crear/formModels/formInitialValues';
import createEmployeFormModel from '../../components/empleado/crear/formModels/createEmployeFormModel';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';
import { mtDividerUpTable, timeToClosedToast } from '../../commons';
import { ModalSessionExpired } from '../../components/generics/ModalSessionExpired';
import { closeSessionGlobal, hasPemissions } from '../../commons/utils';




export const CreateEmployee = () => {


  // USE DISPATCH 
  const dispatch = useDispatch();


  // DATA MODEL 
  const { formId, formField } = createEmployeFormModel;


  // USE STATE 
  const [data, setMsgErrors] = useState([]);


  const [activeStep, setActiveStep] = useState(0);
  const [percentaje_c_Company, setPercentajeCCompany] = useState(2);


  const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);
  

  const  [isSubmitting, setIsSubmitting] = React.useState(false);
  const  [btnText, setBtnText] = React.useState('Crear Empleado');


  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

  const [alert_snack, setAlertSnack] = React.useState(false);
  const [msgSnack, setMsgSnack] = React.useState({
      msg: '',
      status: 'success'
  });


  const currentValidationSchema = validationSchema[activeStep];
  

  // STEPS 
  const steps: string[] = ['Datos Basicos', 'Laboral',  'Seguridad social', 'Familia', 'Dotacion', 'Pruebas de ingreso'];

  const isLastStep = activeStep === steps.length - 1;


  // USE EFFECT 
  useEffect(() => {
    
     getDataInpusToCreateEmploye(); 

  }, []);


  const getDataInpusToCreateEmploye = async() => {
     
        const response = await dispatch( getEmployeDataCreateStore() );
  }
  


  const lastStep = () => {


    if (activeStep == 0) return;
    
    setActiveStep(activeStep - 1);  
  }


  const _handleSubmit = (values:any, actions:any) => {

    

    if (isLastStep) {

      _submitForm(values, actions);

    } else {

      setActiveStep(activeStep + 1);
      actions.setTouched({});
      actions.setSubmitting(false);

    }

  }


  const  _renderStepContent = (steps: any) => {
    switch (steps) {
      case 0:
        return <InformacionBasica formField={formField} />;
      case 1:
        return <Laboral  formField={formField} />;
      case 2:
        return <SeguridadSocial formField={formField} />;
      case 3:
        return <Familia formField={formField}  />;
      case 4:
        return <Dotacion formField={formField} />;
      case 5:
        return <PruebasIngreso formField={formField} />;
      default:
        return <div>Not Found</div>; 
    }
  }



  const _submitForm = async(values:any, actions:any) => {


    const havePermissions = await hasPemissions('modulo.thumano', 'modulo.empleados', 'create');
  
  
    if( !havePermissions ){
      
        await validateLsPermissions('No tienes pemisos para (Crear) empleado.');

        return false;                                                             
        
    }


    actions.setSubmitting(true);
    setIsSubmitting(true);
    setBtnText('Un momento...')

    const response = await dispatch( saveEmployee(values, setPercentajeCCompany) );


    setIsSubmitting(false);
    setBtnText('Crear Tipo Novedad')

    
    actions.setSubmitting(false);


    const result = await validateResponseCreate(response, ' (Crear Empleado.) ');
  
    if (!result) {
        return false;
    }


    if (response.ok) {
      
      const errors:any = {
        msg: response.message,
        status: 'success'
      };
    
      await setMsgSnack(errors);
      await setAlertSnack(true);


      setActiveStep(0);
      actions.resetForm();
      actions.setSubmitting(false);

      

    }


    

  }




  const validateLsPermissions = async(message:string) => {
  
      const errors:any = {
        msg: message,
        status: 'error'
      };
    
      await setMsgSnack(errors);
      await setAlertSnack(true);
    
    
  }
  
  
  const validateResponseCreate = async(response:any, textActionConcat: string) => {
        
        
      if (  response.code == 401  ) {
        await localStorage.removeItem('lastSelectedQypht');
        await closeSessionGlobal();
        setModalSessionExpired(true);
        return false;
      }

    
      // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION 
      if (!response.ok && response.code == 403 ) { 

      
        const errors:any = {
          msg: response.errors[0]+' '+textActionConcat,
          status: 'error'
        };
      
        await setMsgSnack(errors);
        await setAlertSnack(true);

      
        return false;
        
      }


      // 403 EL DATO YA SE ENCUENTRA REGISTRADO
      if (!response.ok && response.code == 409 ) { 
    
        const errors:any = {
            msg: response.errors[0]+' '+textActionConcat,
            status: 'error'
        };
        
        await setMsgSnack(errors);
        await setAlertSnack(true);

        return false;
      }

      
      // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO 
      if (!response.ok && response.code == 400 ) { 

        const errors:any = [];

        response.errors.forEach( (element:any) => {
            
            errors.push({
              type: 'error',
              text: element
            })
        });

          
        setMessagesAlerts(errors);
        return false;

      }

      return true;
    
  } 





  return (
    <Box sx={{ width: '100%' }}>
     

     <ModalSessionExpired  open={modalSessionExpired}  />
     <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />
     <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>
  
  

    <BreadCrumbsAndTitle
              title="Crear Empleado" 
              mainModule="Talento Humano" 
              parent="Crear Empleado"
              action="/talento-humano/empleado" />

    <Divider sx={{ marginBottom: mtDividerUpTable }}/>
       
  
  
  <Stepper activeStep={activeStep}>
    {steps.map((label:any, index:any) => {
      const labelProps: {
        optional?: React.ReactNode;
        error?: boolean;
      } = {};
      // if (isStepFailed(index)) {
      //   labelProps.optional = (
      //     <Typography variant="caption" color="error">
      //       Faltan campos por diligenciar
      //     </Typography>
      //   );
      //   labelProps.error = true;
      // }

      return (
        <Step key={label}>
          <StepLabel {...labelProps}>{label}</StepLabel>
        </Step>
      );
    })}
  </Stepper>

     <Formik
        initialValues={formInitialValues}
        validationSchema={currentValidationSchema}
        onSubmit={_handleSubmit}
      >
     <Card style={{ marginTop: 50,  padding: 20}}>
       <Form id={formId}>
         {_renderStepContent(activeStep)}
        <div style={{ display: 'flex', justifyContent: 'end', marginTop: 25}}>
          

          {
            activeStep > 0 && <Button
                                style={{margin:5}}
                                variant="contained"
                                onClick={lastStep}
                                color="primary">
                                Atras
                              </Button>
          }
          <Button
              disabled={isSubmitting}
              style={{margin:5}}
              type="submit"
              variant="contained"
              color={ isLastStep ? "success" : "primary"}
            >
              {isLastStep ? btnText : "Siguiente"}
          </Button>

          
        </div>
        </Form>
     </Card>
     
     </Formik>
</Box>
  )
}
